import {CustomIconButton} from "@/app/[locale]/common/components/CustomIconButton/CustomIconButton";
import {ArrowIcon} from "@/app/[locale]/common/assets/ArrowIcon/ArrowIcon";
import s from './Accordion.module.scss';
import {TAccordionProps} from "@/app/[locale]/common/components/Accordion/types";
import {Link} from '@/i18n/routing';

export const Accordion = ({ isOpen, trigger, list, className, handleOpen, handleClose }: TAccordionProps) => {
    const toggleDropdown = isOpen ? handleClose : handleOpen;

    return (
        <div className={className}>
            <CustomIconButton
                className={s.accordion_trigger}
                rightIcon={<ArrowIcon active={isOpen} />}
                onClick={toggleDropdown}
            >
                { trigger }
            </CustomIconButton>

            {
                isOpen &&
                <div className={s.accordion_container}>
                    <ul className={s.dropdownMenuContent}>
                        {list.map((item, index) => (
                            <Link key={index} href={item.href} className={s.accordion_item}>
                                {item.title}
                            </Link>
                        ))}
                    </ul>
                </div>
            }
        </div>
    );
};